import { render } from "./NewCase.vue?vue&type=template&id=4768427e&scoped=true&ts=true"
import script from "./NewCase.vue?vue&type=script&lang=ts"
export * from "./NewCase.vue?vue&type=script&lang=ts"

import "./NewCase.vue?vue&type=style&index=0&id=4768427e&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4768427e"]])

export default __exports__